<template>
  <div class="inventory-picking-tab tb">
    <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
    <manage v-if="tabIndex === 0"></manage>
    <device-list v-if="tabIndex === 1"></device-list>
  </div>
</template>

<script>
import manage from './children/inventory_picking_manage';
import deviceList from './children/inventory_picking_device_list';

export default {
  name: 'contractInventoryPicking',
  props: {},
  components: {
    deviceList,
    manage,
  },
  mixins: [],
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    tabData() {
      const tabData = [];
      if (this.funcView.contract_inventory_picking_list) {
        tabData.push({
          name: this.$t('crm_contract_inventory_picking.ding_dan'),
          value: 0,
        });
      }
      if (this.funcView.contract_inventory_picking_device_list) {
        tabData.push({
          name: this.$t('crm_contract_inventory_picking.she_bei'),
          value: 1,
        });
      }
      return tabData;
    }
  },
  mounted() {
    this.getFuncView(null, () => {
      // 设置默认选中的tab索引
      if (this.funcView.contract_inventory_picking_list) {
        this.tabIndex = 0;
      } else if (this.funcView.contract_inventory_picking_device_list) {
        this.tabIndex = 1;
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.inventory-picking-tab {
  padding-left: 0 !important;
}
</style>
